<template>
  <slot />
  <v-snackbar
    v-model="visible"
    :color="color"
    location="top center"
    :timeout="timeout"
    variant="elevated"
    @update:model-value="onClose"
  >
    {{ text }}
    <template #actions>
      <v-btn
        variant="text"
        size="small"
        icon
        @click="visible = false"
      >
        <v-icon size="small">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { ref, provide } from "vue";
import { XMessageKey } from "./useXMessage";

const visible = ref(false);
const text = ref("");
const color = ref("primary");
const timeout = ref(5000);

const xMessageApi = {
  show(content: string, options?: { color?: string; timeout?: number }) {
    text.value = content;
    color.value = options?.color ?? "primary";
    timeout.value = options?.timeout ?? 5000;
    visible.value = true;
  },
  success(content: string, options?: { timeout?: number }) {
    xMessageApi.show(content, { ...options, color: "success" });
  },
  error(content: string, options?: { timeout?: number }) {
    xMessageApi.show(content, { ...options, color: "error" });
  },
  warning(content: string, options?: { timeout?: number }) {
    xMessageApi.show(content, { ...options, color: "warning" });
  },
  info(content: string, options?: { timeout?: number }) {
    xMessageApi.show(content, { ...options, color: "info" });
  }
};

provide(XMessageKey, xMessageApi);

const onClose = () => {
  visible.value = false;
};
</script>
